/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";
import { auditLogRefreshKeys, userDropdownRefreshKeys } from "./sharedRefreshKeys";
import { LEGACY_MUTATION_QUERY_KEYS } from "./legacyQueryKeys";

const employeeListRefreshKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.employees),
  getBaseQueryKey(Query_Keys.network_guests),
  LEGACY_MUTATION_QUERY_KEYS.employee,
  getBaseQueryKey(Query_Keys.global_employee_search),
  getBaseQueryKey(Query_Keys.archived_employees),
  getBaseQueryKey(Query_Keys.audience_per_restaurant),
  getBaseQueryKey(Query_Keys.dashboard_audience),
  getBaseQueryKey(Query_Keys.employees_dropdown),
  getBaseQueryKey(Query_Keys.search_guests),
  getBaseQueryKey(Query_Keys.guest_details),
  getBaseQueryKey(Query_Keys.associated_guest_restaurants),
  getBaseQueryKey(Query_Keys.guest_activity_log),
  getBaseQueryKey(Query_Keys.import_log_metric),
  getBaseQueryKey(Query_Keys.import_logs),
  getBaseQueryKey(Query_Keys.resolved_conflict),
  getBaseQueryKey(Query_Keys.convertible_restaurants),
  userDropdownRefreshKeys,
);

const employeeDiscountRefreshKeys = mergeQueryKeys(
  employeeListRefreshKeys,
  getBaseQueryKey(Query_Keys.employee_discount_report),
  getBaseQueryKey(Query_Keys.discount_card_logs),
  getBaseQueryKey(Query_Keys.group_members),
  getBaseQueryKey(Query_Keys.dynamic_discount_events_matrix),
);

// The card view shows special perq group members by name, so a renamed employee must refetch it.
const employeeUpdateRefreshKeys = mergeQueryKeys(
  employeeDiscountRefreshKeys,
  getBaseQueryKey(Query_Keys.show_discount_card)
);

export const employeeMutationKeyGroups = {
  create: employeeListRefreshKeys,
  update: employeeUpdateRefreshKeys,
  delete: employeeDiscountRefreshKeys,
  restore: employeeListRefreshKeys,
  import: mergeQueryKeys(employeeListRefreshKeys, auditLogRefreshKeys),
  discountCardAction: employeeDiscountRefreshKeys,
  convert: employeeDiscountRefreshKeys,
};

export const employeeRemoveKeyGroups = {
  discountCardAction: [getBaseQueryKey(Query_Keys.discount_cards)],
};
